import { render, staticRenderFns } from "./PatentWipoXmlUploadForm.vue?vue&type=template&id=84a61a66&"
import script from "./PatentWipoXmlUploadForm.vue?vue&type=script&lang=js&"
export * from "./PatentWipoXmlUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentWipoXmlUploadForm.vue?vue&type=style&index=0&id=84a61a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports